import { CssBaseline } from "@mui/material";
import { Routes, Route } from "react-router-dom";
import { ProtectedRoute } from "src/components/auth/ProtectedRoute";
import { AppLayout } from "src/components/layout/AppLayout";
import { HomePage } from "src/pages/HomePage";
import { ArtifactsPage } from "src/pages/ArtifactsPage";
import { UIComponentsPage } from "src/pages/UIComponentsPage";
import { DashboardPage } from "src/pages/DashboardPage";
import { SettingsPage } from "src/pages/SettingsPage";
import { ComponentDetailPage } from "src/pages/ComponentDetailPage";
import { GettingStartedPage } from "src/pages/GettingStartedPage";
import { DebugPage } from "src/pages/DebugPage";
import { LabPage } from "src/pages/LabPage";

/**
 * Main application component with full navigation.
 *
 * This template creates a complete Insight-style app with:
 * - Responsive navigation drawer (desktop sidebar, mobile overlay)
 * - Collapsible desktop drawer
 * - Theme switcher
 * - Example pages demonstrating layout usage
 */
function App() {
  return (
    <>
      <CssBaseline />
      <Routes>
        <Route
          element={
            <ProtectedRoute>
              <AppLayout />
            </ProtectedRoute>
          }
        >
          <Route path="/" element={<HomePage />} />
          <Route path="/ui-components" element={<UIComponentsPage />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/component/:id" element={<ComponentDetailPage />} />
          <Route path="/getting-started" element={<GettingStartedPage />} />
          <Route path="/debug" element={<DebugPage />} />
          <Route path="/artifacts" element={<ArtifactsPage />} />
          <Route path="/labs/:labId/*" element={<LabPage />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
